import { Component } from '@angular/core';
import { SmsAccount } from './sms-account.model';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { ClientsService } from '../../../../services/clients/clients.service';
import { Globals } from '../../../../globals/Globals';
import { SuperClass } from '../../../../superclass/SuperClass';
import { WsService } from '../../../../services/websocket/WsService';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-analytics-sms-accounts',
  templateUrl: './sms-accounts.component.html',
  styleUrls: ['./sms-accounts.component.css'],
})
export class AnalyticsSmsAccountsComponent extends SuperClass {
  selectedRow: SmsAccount;
  newAccount: SmsAccount;
  newAccountForm: FormGroup;
  selectedRowForm: FormGroup;

  display = false;
  apiTypes: any[] = [];
  apiType = {};
  accounts: SmsAccount[];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Accounts' },
      {
        label: 'SMS Accounts',
        routerLink: [
          { outlets: { sub: [RouterConst.ANALYTICS_SMS_ACCOUNTS] } },
        ],
      },
    ]);
    this.newAccount = new SmsAccount();
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  reloadData() {
    this.http_getAllAccounts('sms', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.accounts = data.payload;
      }
    });
    this.http_getSmsApiTypes((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        data.payload.forEach(element => {
          const apiType = {};
          apiType['label'] = element;
          apiType['value'] = element;
          this.apiTypes.push(apiType);
        });
      }
    });

    this.selectedRowForm = this.fb.group({
      name: new FormControl('', Validators.required),
      apiType: new FormControl('', Validators.required),
      apiKey: new FormControl('', Validators.required),
      secret: new FormControl('', Validators.required),
    });

    this.newAccountForm = this.fb.group({
      name: new FormControl('', Validators.required),
      apiType: new FormControl('', Validators.required),
      apiKey: new FormControl('', Validators.required),
      secret: new FormControl('', Validators.required),
    });
  }

  selectRow(e) {
    this.selectedRow = new SmsAccount(e.data);
  }

  saveAccount() {
    const requiredFields = [
      { id: 'name', value: this.selectedRow.name, fieldName: 'Name' },
      { id: 'apiType', value: this.selectedRow.apiType, fieldName: 'Api Type' },
      { id: 'apiKey', value: this.selectedRow.apiKey, fieldName: 'Api Key' },
      { id: 'secret', value: this.selectedRow.secret, fieldName: 'Secret' },
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    this.http_updateAccounts(this.selectedRow, 'sms', (data: any) => {
      this.showSuccessMessage('Account has been updated');
      this.unselectRow();
      this.accounts = data.payload;
    });
  }

  addNewAccount() {
    this.display = true;
    this.newAccount = new SmsAccount();
  }

  createNewAccount() {
    const requiredFields = [
      { id: 'new_name', value: this.newAccount.name, fieldName: 'Name' },
      {
        id: 'new_apiType',
        value: this.newAccount.apiType,
        fieldName: 'Api Type',
      },
      { id: 'new_apiKey', value: this.newAccount.apiKey, fieldName: 'Api Key' },
      { id: 'new_secret', value: this.newAccount.secret, fieldName: 'Secret' },
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    this.http_addAccount(this.newAccount, 'sms', (data: any) => {
      this.showSuccessMessage('Account has been created');
      this.unselectRow();
      this.accounts = data.payload;
    });
    this.display = false;
  }

  deleteAccount() {
    this.http_deleteAccount(this.selectedRow, 'sms', (data: any) => {
      this.showSuccessMessage('Account has been deleted');
      this.unselectRow();
      this.accounts = data.payload;
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/sms-accounts/sms-accounts.component.ts